const fogCN = {
    FOG_01:'Modification success,return after 3 seconds.',
    FOG_02:'The verification email has been sent. Please check it in time.',
    FOG_03:'Please input username',
    FOG_04:'The password twice inconsistent',
    FOG_05:'Please re-enter the new password.',
    FOG_06:'Please enter the new password.',
    FOG_07:'Confirm',
    FOG_10:'Back to login',
    FOG_11:'Send verification email',
}
export default fogCN


// WEBPACK FOOTER //
// ./src/lan/en/en_fog.js